import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";

import { Header, Segment } from "semantic-ui-react";
import ErrorBoundary from "../../components/errorBoundaries/ErrorBoundary.jsx";

import { ROUTES } from "../../constants/routing";
import { exchangeFederatedCode } from "../../state/reducers/authentication/federatedAuthenticationActions.js";

export default function LoginFederatedCallback() {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  // exchange code
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const code = params.get("code");
    const state = params.get("state");

    if (code) {
      dispatch(exchangeFederatedCode({ code, state }));
    } else {
      console.warn("No code found in callback URL");
      history.replace(ROUTES.LOGIN); // fallback
    }
  }, [location]);

  // @todo refactor to a copy key (i18n) instead of hard-coding text below...

  return (
    <div className="sentry-form">
      <Header as="h4" inverted textAlign="center">
        Signing you in with your corporate account...
        <br />
        (just a moment)
      </Header>
    </div>
  );
}
